import type { PropsWithChildren } from "react";
import { Helmet as BaseHelmet, HelmetProps } from "react-helmet-async";

export type { HelmetProps };
export { HelmetProvider, type MetaProps } from "react-helmet-async";

export default function Helmet(props: PropsWithChildren<HelmetProps>) {
  return <BaseHelmet encodeSpecialCharacters {...props} />;
}
